{
    "misc": {
        "chooselang": "Selecciona tu idioma",
        "langprogress": "Progreso de traducción"
    },
    "header": {
        "home": "Inicio",
        "language": "Idioma",
        "about": "Sobre nosotros",
        "write": "Escribir",
        "account": "Cuenta"
    },
    "footer": {
        "disclaimer": "no está afiliado con Scratch, el equipo de Scratch o la Fundación Scratch.",
        "headingabout": "Acerca de",
        "headinglinks": "Recursos",
        "headingcommunity": "Comunidad",
        "aboutlink": "Acerca y créditos",
        "licenselink": "Licencia",
        "statuslink": "Estado",
        "articleslink": "Artículos",
        "googlebusinesslink": "Google Business",
        "issuelink": "Reportar un problema",
        "reviewlink": "Deja una reseña",
        "forumlink": "Tema del foro",
        "githublink": "GitHub",
        "discord": "Discord"
    },
    "main": {
        "welcome": "¡Bienvenido a The Scratch Channel!",
        "back-cat": "Volver a categorías",
        "readmore": "Leer más",
        "by": "Por",
        "date": "Fecha",
        "category": "Categoría"
    },
    "write": {
        "heading": "Crear artículo",
        "title": "Título",
        "author": "Autor",
        "date": "Fecha",
        "category": "Categoría",
        "content": "Contenido",
        "submit": "Enviar",
        "cancel": "Cancelar",
        "unauthorised": "No autorizado para crear artículos",
        "title-err": "El título es obligatorio",
        "title-placeholder": "Introduce el título de tu artículo..."
    },
    "signup": {
        "heading": "Registrarse",
        "email-placeholder": "Correo electrónico",
        "password-placeholder": "Contraseña",
        "username-placeholder": "Nombre de usuario",
        "register": "Registrar"
    },
    "login": {
        "emailpass-error": "Por favor ingresa correo y contraseña.",
        "signin": "Iniciar sesión"
    },
    "account": {
        "welcome": "Bienvenido",
        "logout": "Cerrar sesión",
        "login": "Iniciar sesión",
        "signup": "Registrarse",
        "liketodo": "¿Qué te gustaría hacer?"
    }
}
